import { Component } from '@angular/core';

@Component({
  selector: 'app-abo-autocom',
  templateUrl: './abo-autocom.component.html',
  styleUrls: ['./abo-autocom.component.scss']
})
export class AboAutocomComponent {

}
